import React, { useState } from 'react'

// next components
import { useDispatch } from 'react-redux'

// custom functions
import { useViewport } from 'utils'
import { useAuthentication } from 'hooks/useAuthentication'

// custom component
import PriceInput from 'components/Input/PriceInput'

// resource
import BackIcon from 'assets/icons/back-arrow.svg?component'

// styles
import styles from './index.module.scss'

// solana
import { PublicKey, LAMPORTS_PER_SOL } from '@solana/web3.js'
import { listNFT } from 'utils/auction.util'
import { useMetaplex } from 'hooks/useMetaplex'
import LoadingButton from 'components/Button/LoadingButton'
import GradientButton from 'components/Button/GradientButton'

// apis
import listingsAPI from 'apis/listings'

export interface ListArtworkDetailProps {
  data: {
    mintAddress: string
    name?: string
    image?: string
    animation_url?: string
    category?: string
    original?: {
      image?: string
    }
  }
  onClose: (status: string, price: string) => void
}

const ListArtworkDetail = ({ data, onClose }: ListArtworkDetailProps) => {
  const viewport = useViewport()
  const dispatch = useDispatch()
  const [price, setPrice] = useState<string>('')
  const [listStatus, setListStatus] = useState(false)
  const [showLoading, setShowLoading] = useState(false)
  const { metaplex: mx } = useMetaplex()
  const { refreshToken } = useAuthentication()

  const closeModal = () => {
    setShowLoading(false)
    setPrice(null)
    onClose('list-close', price)
    // setTimeout(() => {
    //   setListStatus(false)
    // }, 1000)
  }

  const handleListNFTClick = async () => {
    setShowLoading(true)

    await refreshToken()

    const result = await listNFT(mx, new PublicKey(data.mintAddress), parseFloat(price) * LAMPORTS_PER_SOL)
    let listingResponse = null
    if (result) {
      // retry upto 3 times
      for (let i = 0; i < 3 && listingResponse == null; i++)
        try {
          await mx.rpc().confirmTransaction(
            result.signature,
            {
              blockhash: result.blockhash,
              lastValidBlockHeight: result.lastValidBlockHeight,
            },
            'processed'
          )
          listingResponse = await listingsAPI.listNft(data.mintAddress.toString(), { amount: price })
        } catch (e) {
          console.error(`failed to post listing: attempt ${i + 1} of 3: ${(e as Error)?.message}`)
          console.error(e)
        }

      onClose('listed', price)

      dispatch({ type: 'set', isGetListedNFTs: false })
    }

    if (!result || !listingResponse) {
      setShowLoading(false)
    }
  }

  return (
    <div className="w-full">
      <div className={`${styles.container} `}>
        <div className={`w-full flex justify-between mt-[0px] lg:mt-[60px]`}>
          <div className={styles.auctionDetailText} onClick={() => closeModal()}>
            <BackIcon />
            List Artwork
          </div>
        </div>

        <div>
          <div className="w-full mt-[30px] lg:mt-[30px]">
            <div className={styles.auctionStart}>Listing Price</div>
          </div>
          <div className="mt-[15px] w-full">
            <PriceInput
              value={price ?? ''}
              placeholder="Set the listing price"
              backgroundColor="var(--bg-151515-EEEDEB)"
              fullWidth
              borderRadius={23}
              min={0}
              height={viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? '50px' : '45px'}
              onChange={value => setPrice(value)}
            />
          </div>

          <div className="mt-[15px] mb-[45px] lg:mb-[80px] w-full">
            {showLoading ? (
              <LoadingButton fullWidth height={50} />
            ) : (
              <GradientButton
                label="List Artwork"
                fullWidth
                height={50}
                disabled={parseFloat(price ?? '0') <= 0 || price === ''}
                color="var(--background-main-color)"
                onClick={() => handleListNFTClick()}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListArtworkDetail
